import React, { useState, useContext, useEffect, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  Add,
  PeopleOutline,
  Search,
  Edit,
  CreditCardOutlined,
} from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import {
  TextField,
  Box,
  Tooltip,
  Grid,
  Alert,
  Stack,
  Typography,
} from "@mui/material";
import Moment from "moment";

import StatusAdmin from "views/dialog/StatusAdmin";
import EditClientAdmin from "views/dialog/EditClientAdmin";
import ViewsDependentsAdmin from "views/dialog/ViewsDependentsAdmin";
import ViewsCardCollectionAdmin from "views/dialog/ViewsCardCollectionAdmin";
import LoadUserProfile from "components/services/LoadUserProfile";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  AntSwitch,
  ButtonTableGrid1,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const infoStyle = {
  color: "#1d1d1b",
  fontSize: 10,
  fontWeight: "bold",
  margin: "3px 0",
  borderBottom: "1px solid #f2f2f2",
  paddingLeft: 2,
  padding: "2px 5px 2px 15px",
};

export default function ClientsListAdmin() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [rows, setRows] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [openViewsDependents, setOpenViewsDependents] = useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openCard, setOpenCard] = useState(false);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    userData: "",
  });

  const [state] = useState({
    columns: [
      {
        headerName: "ID",
        field: "id",
        width: 30,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Cliente",
        field: "allNames",
        flex: 1,
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        sortable: false,
        hideable: false,
      },
      ...(UserAuth.profile_id === 2
        ? [
            {
              headerName: "Gestor",
              field: "user.allNames",
              width: 200,
              headerAlign: "center",
              headerClassName: "super-app-theme--header",
              cellClassName: (params) => {
                return clsx("super-app", {
                  celAll: params.value,
                });
              },
              renderCell: (params) => {
                return (
                  <div style={{ whiteSpace: "normal" }}>
                    {renderProfile(params.row)}
                  </div>
                );
              },
              sortable: false,
              hideable: false,
            },
          ]
        : []),
      {
        headerName: "Documento",
        field: "documentId",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 100,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        field: "action1",
        headerName: "----",
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        width: 100,
        renderCell: (params) => (
          <ButtonTableGrid1
            onClick={openViewsDependentsValue(params)}
            style={{ margin: "12px 0" }}
          >
            Dependientes
          </ButtonTableGrid1>
        ),
      },
      {
        headerName: "Estado",
        field: "status",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          const text =
            params.value === 1
              ? "ACTIVO"
              : params.value === 99
              ? "PENDIENTE"
              : "INACTIVO";
          const color =
            params.value === 1
              ? "green"
              : params.value === 99
              ? "#000000"
              : "red";
          return (
            <>
              <b style={{ color: color, fontSize: 9 }}>{text}</b>
            </>
          );
        },
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 100,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Editar" arrow>
                  <Edit style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Editar"
              onClick={openEditValue(params)}
            />
          );

          actions.push(
            <GridActionsCellItem
              key="disable"
              sx={{ ml: "-18px" }}
              icon={
                <Tooltip title="Tarjetas" arrow>
                  <CreditCardOutlined style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Tarjetas"
              onClick={openCardValue(params)}
            />
          );

          if (parseInt(params.row.status) === 0) {
            // Si el perfil está deshabilitado, mostramos el icono para habilitarlo
            actions.push(
              /* <GridActionsCellItem
                key="enable"
                icon={
                  <Tooltip title="Habilitar" arrow>
                    <AddCircle style={{ fontSize: 24, color: "green" }} />
                  </Tooltip>
                }
                label="Habilitar"
                onClick={openStatusValue(params)}
              />*/
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ ml: "-8px" }}
              >
                <Tooltip title="Habilitar" arrow>
                  <AntSwitch
                    checked={parseInt(params.row.status) === 0 ? false : true}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={openStatusValue(params)}
                  />
                </Tooltip>
              </Stack>
            );
          } else {
            // Si el perfil está habilitado, mostramos el icono para deshabilitarlo
            actions.push(
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ ml: "-10px" }}
              >
                <Tooltip title="Deshabilitar" arrow>
                  <AntSwitch
                    checked={parseInt(params.row.status) === 0 ? false : true}
                    inputProps={{ "aria-label": "ant design" }}
                    onClick={openStatusValue(params)}
                  />
                </Tooltip>
              </Stack>
            );
            /*actions.push(
              <GridActionsCellItem
                key="disable"
                icon={
                  <Tooltip title="Deshabilitar" arrow>
                    <Cancel style={{ fontSize: 24, color: "#000" }} />
                  </Tooltip>
                }
                label="Deshabilitar"
                onClick={openStatusValue(params)}
              />
            );*/
          }

          return actions;
        },
      },
    ],
  });

  const renderProfile = (row) => (
    <>
      <Typography sx={infoStyle} style={{ fontSize: 12 }}>
        {row.user.allNames}
      </Typography>
      <Typography sx={infoStyle} style={{ fontWeight: 500 }}>
        ({row.user.profile.name})
      </Typography>
    </>
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RefreshTable();
  }, []);

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value; // Obtener el valor del input
    setSearchText(value); // Actualizar el estado del texto de búsqueda

    // Filtrar los datos según el valor de búsqueda
    if (value.trim() !== "") {
      const resultSearch = rowsResponse.filter(
        (item) =>
          removeAccents(item.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.user.allNames.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          ) ||
          removeAccents(item.documentId.toLowerCase()).includes(
            removeAccents(value.toLowerCase())
          )
      );
      setRows(resultSearch);
    } else {
      setRows(rowsResponse); // Restaurar los datos originales si no hay búsqueda
    }
  };

  const RefreshTable = async () => {
    setSearchText("");
    setLoader(true);

    try {
      const response = await axios.get(`${urlServices}clients/list`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      });

      if (response.status === 200) {
        const transformedRows = response.data.map((data) => ({
          ...data,
          prefix: JSON.parse(data.prefix),
          dependents: parseJsonArray(data.dependents),
        }));

        setRows(transformedRows);
        setRowsResponse(transformedRows);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const openStatusValue = (data) => () => {
    setIdRow(data);
    setOpenStatus(true);
  };

  const openEditValue = (data) => () => {
    setIdRow(data);
    setOpenEdit(true);
  };

  const openCardValue = (data) => () => {
    setIdRow(data);
    setOpenCard(true);
  };

  const openViewsDependentsValue = (data) => () => {
    setIdRow(data);
    setOpenViewsDependents(true);
  };

  const handleNewPageRegister = () => () => {
    localStorage.setItem("controllerRouter", "/customers/client-register");
    setOpenNew(true);
  };

  const changeUserProfile = (data) => {
    setValues((prevValues) => ({
      ...prevValues,
      userData: data || null,
    }));

    const filteredRows = data
      ? rowsResponse.filter((item) => item.userId === data.id)
      : rowsResponse;

    setRows(filteredRows);
  };

  const handleCloseViewsDependents = () => setOpenViewsDependents(false);
  const handleCloseStatus = () => setOpenStatus(false);
  const handleCloseEdit = () => setOpenEdit(false);
  const handleCloseCard = () => setOpenCard(false);

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  if (openNew) {
    return <Redirect to="/customers/client-register" />;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack}>
          <PeopleOutline className={classes.iconFilter} /> Listado de clientes
        </div>
        <Card>
          <CardBody>
            {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    {/* Campo de búsqueda */}
                    <TextField
                      variant="outlined"
                      value={searchText}
                      onChange={handleSearchChange}
                      sx={{ mt: 1 }}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <Search
                            position="start"
                            style={{
                              color: "gray",
                              fontSize: 22,
                              marginRight: 10,
                            }}
                          />
                        ),
                      }}
                      fullWidth
                      placeholder="Buscar"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    sx={{
                      display: UserAuth.profile_id === 2 ? "block" : "none",
                    }}
                  >
                    <LoadUserProfile
                      value={values.userData}
                      refresh={changeUserProfile}
                      style={{ marginBottom: 2 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={UserAuth.profile_id === 2 ? 4 : 8}>
                    <div style={{ float: "right" }}>
                      <ButtonStyle0
                        onClick={handleNewPageRegister()}
                        endIcon={<Add />}
                      >
                        Nuevo registro
                      </ButtonStyle0>
                    </div>
                  </Grid>
                </Grid>
                <Grid container>
                  {rows.length > 0 ? (
                    <Grid item xs={12} sm={12}>
                      <Box
                        sx={{
                          "& .super-app.celAll": {
                            fontSize: 12,
                            //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                          },
                          "& .super-app.celActions": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          "& .super-app-theme--header": {
                            backgroundColor: "rgb(242, 242, 242)",
                          },
                          marginTop: 2,
                        }}
                      >
                        <DataGrid
                          rows={rows}
                          columns={state.columns}
                          loading={loader}
                          initialState={{
                            pagination: {
                              paginationModel: { page: 0, pageSize: 10 },
                            },
                          }}
                          pageSizeOptions={[5, 10, 20, 50]}
                          disableRowSelectionOnClick={true}
                          checkboxSelection={false}
                          sx={{
                            [`& .${gridClasses.cell}`]: {
                              display: "flex",
                              alignItems: "center", // Alineación vertical
                              // justifyContent: 'center', // Alineación horizontal
                              wordWrap: "break-word !important",
                              whiteSpace: "normal !important",
                            },
                            /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                          }}
                          getRowHeight={() => "auto"}
                          // autoHeights
                          autoWidth
                        />
                      </Box>
                    </Grid>
                  ) : (
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          alt="loaderGif"
                          src={noDataImg}
                          style={{ width: 300, marginTop: 50 }}
                        />
                        <br></br>
                        <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                          No hay registros para mostrar
                        </b>
                      </center>
                    </Grid>
                  )}
                </Grid>
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {openStatus && (
        <StatusAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
          path="clients"
        />
      )}
      {openEdit && (
        <EditClientAdmin
          open={openEdit}
          exit={handleCloseEdit}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openViewsDependents && (
        <ViewsDependentsAdmin
          open={openViewsDependents}
          exit={handleCloseViewsDependents}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
      {openCard && (
        <ViewsCardCollectionAdmin
          open={openCard}
          exit={handleCloseCard}
          callBackRefresh={RefreshTable}
          id={idRow}
        />
      )}
    </GridContainer>
  );
}
